module.exports = __webpack_public_path__ + "img/scan.5b27daae.svg";